import { styled } from "styled-components";

export const DocumentationCardContainer = styled.div`
  display: flex;
  height: 285px;
  gap: 8px;
  max-width: 350px;
  min-width: 280px;
  width: 0;
  padding: 42px 24px 24px 24px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  background: ${({ theme }) => theme.colors.base};
  border-radius: 4px;
  flex: 1 1 0;

  ${({ theme }) => theme.breakpoints.sm.query} {
    height: fit-content;
    flex: 1;
    width: 100%;
    max-width: revert;
    min-width: 100%;
    gap: 36px;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;

  & > p {
    color: ${({ theme }) => theme.colors.default[400]};
    font-weight: 550;
  }
`;
